/**
 * Pipe that transforms the site icon Amazon s3
 * url to an image on base 64. If the site icon
 * is already in base 64 then it returns and observable of it. 
 */
import { OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subscription, of } from 'rxjs';

/**
 * Pipe that transforms the site icon Amazon s3
 * url to an image on base 64. If the site icon
 * is already in base 64 then it returns and observable of it. 
 */
@Pipe({
  name: 'getReviewData'
})
export class GetReviewDataPipe implements PipeTransform, OnDestroy {
  private data: any = null;
  _subs: Subscription = new Subscription()
  
  constructor(private http: HttpClient) { }

  /**
   * Gets the sw amazon url and download a base 64 image.
   * If the image is in base 64 already it returns an observable
   * of it.
   * @param url The site icon url/source
   * @returns Returns an observable of a base 64 image
   */
  transform(url: string): Observable<any> {
    return url.includes('base64') ? of(url) : this.http.get(url, { responseType: "text" })
  }
  ngOnDestroy(): void {
    this._subs.unsubscribe()
  }

}
